import { useRef } from '@wordpress/element';
import Button from '../button';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * FormFileUpload allows users to select files from their local device.
 *
 * ```jsx
 * import { FormFileUpload } from '@wordpress/components';
 *
 * const MyFormFileUpload = () => (
 *   <FormFileUpload
 *     accept="image/*"
 *     onChange={ ( event ) => console.log( event.currentTarget.files ) }
 *   >
 *     Upload
 *   </FormFileUpload>
 * );
 * ```
 */
export function FormFileUpload({
  accept,
  children,
  multiple = false,
  onChange,
  onClick,
  render,
  __next40pxDefaultSize: _next40pxDefaultSize,
  ...props
}) {
  const ref = useRef(null);
  const openFileDialog = () => {
    ref.current?.click();
  };
  const ui = render ? render({
    openFileDialog
  }) : /*#__PURE__*/_jsx(Button, {
    onClick: openFileDialog,
    __next40pxDefaultSize: true,
    ...props,
    children: children
  });

  // iOS browsers may not reliably handle 'audio/*' in the accept attribute.
  // Adding explicit audio MIME types improves compatibility across all devices.
  const compatAccept = accept?.includes('audio/*') ? `${accept}, audio/mp3, audio/x-m4a, audio/x-m4b, audio/x-m4p, audio/x-wav, audio/webm` : accept;
  return /*#__PURE__*/_jsxs("div", {
    className: "components-form-file-upload",
    children: [ui, /*#__PURE__*/_jsx("input", {
      type: "file",
      ref: ref,
      multiple: multiple,
      style: {
        display: 'none'
      },
      accept: compatAccept,
      onChange: onChange,
      onClick: onClick,
      "data-testid": "form-file-upload-input"
    })]
  });
}
export default FormFileUpload;